import React from 'react';
import { motion } from 'framer-motion';

interface CustomCheckboxProps {
  checked: boolean;
  onChange: () => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange }) => {
  return (
    <motion.div
      className="relative flex items-center justify-center h-4 w-4 cursor-pointer"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <input
        type="checkbox"
        className="absolute opacity-0 h-full w-full cursor-pointer"
        checked={checked}
        onChange={onChange}
      />
      <motion.div
        className={`h-4 w-4 rounded border transition-all duration-150 flex items-center justify-center ${
          checked
            ? 'bg-primary border-primary'
            : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 hover:border-primary'
        }`}
        initial={false}
        animate={{ scale: checked ? 1 : 1 }}
      >
        {checked && (
          <motion.span
            className="material-symbols-outlined text-white text-xs"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 700, damping: 30 }}
          >
            check
          </motion.span>
        )}
      </motion.div>
    </motion.div>
  );
};

export default CustomCheckbox;